// Extract subdomain from current URL
// Assuming to always run on client-side (browser)
export const getSubdomain = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const hostname = window.location.hostname;

  // For localhost during development
  if (hostname === "localhost") {
    // Return a default or from query param for testing
    const params = new URLSearchParams(window.location.search);
    return params.get("subdomain") ?? "";
  }

  // For production with actual subdomains
  const hostParts = hostname.split(".");

  // Check if we have enough parts for a subdomain
  // Example: app.lokasi.com → ['app', 'lokasi', 'com']
  // Example: app.dev.lokasi.com → ['app', 'dev', 'lokasi', 'com']
  // Example: app.staging.lokasi.com → ['app', 'staging', 'lokasi', 'com']
  const isProduction = import.meta.env.MODE === "production";
  const hostLengthLimit = isProduction ? 3 : 4;
  const validHostName =
    hostParts.length === hostLengthLimit &&
    hostParts[hostParts.length - 1] === "com" &&
    hostParts[hostParts.length - 2] === "lokasi";
  if (validHostName) {
    return hostParts[0];
  }

  // No subdomain found (example.com)
  return "";
};
